import React, {useEffect, useState} from "react"
import {Card, Switch} from "@blueprintjs/core"
import {useDispatch, useSelector} from "react-redux"
import handleBooleanChange from "../../../core/utils/handleChangehelpers"
import {
    classesSelector,
    getDisplayDataColumns,
    getRefDbDataContext,
    metabolitesSelector,
} from "../../redux/refdb.selector"

import {
    IMultiSelectItemState,
    MultiSelectString,
} from "../../../core/components/MultiSelectString"
import {
    dataClean,
    loadClassesAction,
    loadMetabolitesExternalAction,
    setDisplayDataContextAction,
    setTableColumn,
} from "../../redux/refdb.actions"
import {MultiSelectObject} from "../../../core/components/MultiSelectObject"

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DisplayOptionsCardProps {}

const DisplayOptionsCard: React.FC<DisplayOptionsCardProps> = () => {
    const dispatch = useDispatch()
    const contextData = useSelector(getRefDbDataContext)
    const columns = useSelector(getDisplayDataColumns)
    const updateSwitch = (name: string, selected: any) => {
        const newContext = {
            ...contextData,
            [name]: {value: contextData[name].value, enable: selected},
        }

        dispatch(setDisplayDataContextAction(newContext))
    }

    const updateBoolean = (name, selected) => {
        const newContext = {
            ...contextData,
            [name]: selected,
        }
        dispatch(dataClean())
        dispatch(setDisplayDataContextAction(newContext))
    }

    const updateHmdbId = (name, selected) => {
        const newContext = {
            ...contextData,
            [name]: selected,
        }
        if (columns && columns.length > 0) {
            columns.find((column) => column.id === "hmdbId").hide = !selected
            dispatch(setTableColumn(columns))
        }
        dispatch(setDisplayDataContextAction(newContext))
    }

    const handleSelect = (e: IMultiSelectItemState) => {
        const newContext = {
            ...contextData,
            [e.name]: {value: e.selected, enable: contextData[e.name].enable},
        }

        dispatch(dataClean())
        dispatch(setDisplayDataContextAction(newContext))
    }

    useEffect(() => {
        dispatch(loadClassesAction(true))
        dispatch(loadMetabolitesExternalAction())
    }, [])

    const classes = useSelector(classesSelector)
    const metabolites = useSelector(metabolitesSelector)

    return (
        <Card>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={contextData.classes.enable}
                    labelElement="Restrict class"
                    onChange={handleBooleanChange((value) =>
                        updateSwitch("classes", value)
                    )}
                />

                <MultiSelectString
                    disabled={!contextData.classes.enable}
                    selected={contextData.classes.value}
                    items={classes || []}
                    handleSelect={handleSelect}
                    name="classes"
                />
            </div>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={contextData.metabolites.enable}
                    labelElement="Restrict metabolites"
                    onChange={handleBooleanChange((value) =>
                        updateSwitch("metabolites", value)
                    )}
                />

                <MultiSelectObject
                    disabled={!contextData.metabolites.enable}
                    selected={contextData.metabolites.value}
                    items={metabolites || []}
                    handleSelect={handleSelect}
                    name="metabolites"
                />
            </div>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={contextData.showHmdbId}
                    labelElement="Show HMDB IDs"
                    onChange={handleBooleanChange((value) =>
                        updateHmdbId("showHmdbId", value)
                    )}
                />
            </div>
        </Card>
    )
}

export default DisplayOptionsCard
